import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared.module';
import { DateTimeInputComponent } from './date-time-input.component';
import { SharedRoutingModule } from '../shared-routing.module';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskModule } from 'ngx-mask';

const maskConfig: Partial<IConfig> = {
    validation: false,
};
@NgModule({
    declarations: [DateTimeInputComponent],
    imports: [
        CommonModule,
        SharedRoutingModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(maskConfig),

    ],
    exports: [DateTimeInputComponent]
})
export class DateTimeInputModule { }
